<div class="coworking-confirm" *ngIf="!isCompany">
  <img [src]="getImage" />
  <p>{{ "coworking.confirm.disclaimer" | translate }}</p>
</div>

<div class="coworking-confirm" *ngIf="isCompany">
  <img [src]="getImage" />
  <p>{{ "company.confirm.disclaimer" | translate }}</p>
</div>
